// Link de rastreio e rótulos de status — usados pela API (para o CSV exportado
// levar o link pronto) e pela tela (para mostrar o mesmo link). Uma regra só:
// a tela de Pedidos tinha a dela, e um segundo lugar montando a URL de outro
// jeito seria o mesmo pedido com dois links.

/** Link no Melhor Rastreio. Com a transportadora conhecida vai direto para a
 *  página dela (/app/jadlog/CODIGO); sem ela, para a busca genérica. */
export function linkRastreio(carrier: string | null | undefined, code: string): string {
  const slug = (carrier ?? '').split(' - ')[0].trim().toLowerCase().replace(/[^a-z0-9]/g, '')
  return slug
    ? `https://melhorrastreio.com.br/app/${slug}/${encodeURIComponent(code)}`
    : `https://melhorrastreio.com.br/rastreio/${encodeURIComponent(code)}`
}

/** Status do pedido no WsFull, em português. */
export const STATUS_PEDIDO: Record<string, string> = {
  pending: 'Pendente', imported: 'Importado', awaiting_label: 'Aguardando etiqueta',
  reserved: 'Liberado', picking: 'Em separação', packed: 'Embalado', shipped: 'Expedido',
  invoiced: 'Faturado', divergent: 'Divergente', returned: 'Devolvido', cancelled: 'Cancelado',
}

/** Status do envio na transportadora (Melhor Envio), em português. */
export const STATUS_ENVIO: Record<string, string> = {
  pending: 'Etiqueta pendente', authorized: 'Etiqueta autorizada', generated: 'Etiqueta gerada',
  printed: 'Etiqueta impressa', posted: 'Postado', delivered: 'Entregue', canceled: 'Cancelado',
}
